require('dom-slider');

const { slideToggle } = window.domSlider;

const accordionButtons = document.querySelectorAll('.block-accordion__button');

const toggleAccordion = (e) => {
	e.preventDefault();

	e.currentTarget.classList.toggle('active');

	slideToggle({
		element: e.currentTarget.parentElement.querySelector(
			'.block-accordion__item-content'
		),
		slideSpeed: 400,
		easing: 'ease-in-out',
	});
};

const accordion = () => {
	if (accordionButtons.length) {
		accordionButtons.forEach((accordionButton) => {
			accordionButton.addEventListener('click', toggleAccordion);
		});
	}
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		accordion();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
